import * as React from 'react';

const ArrowDownSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="arrow-down_svg__eds-icon--down-arrow_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="arrow-down_svg__eds-icon--down-arrow_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M12 20l.2-.2 5.8-5.6-.7-.8-4.8 4.7V4h-1v14.1l-4.8-4.7-.7.7z"
        />
    </svg>
);

ArrowDownSvg.displayName = 'ArrowDownSvg';
export default ArrowDownSvg;
